export const url = process.env.REACT_APP_URL ?? "";
export const API_URL = process.env.REACT_APP_API_URL;
export const WEB_SOCKET_URL = process.env.NEXT_PUBLIC_WEB_SOCKET_URL;

export const SKILLBREW_APP_API_BASE_URL = process.env.REACT_APP_API_URL ?? "";
export const SKILLBREW_APP_API_BASE_URL_V2 = process.env.REACT_APP_API_URL_v2 ?? "";
export const SKILLBREW_APP_WEBSOCKET_BASE_URL = WEB_SOCKET_URL;
export const S3MediaURL = process.env.NEXT_PUBLIC_S3MediaURL ?? "";
export const SKILLBREW_PAYMENTS_APP_URL =
  process.env.REACT_APP_SKILLBREW_PAYMENTS_APP_URL;
export const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME ?? "";

export const APP_NAME = "SKILLBREW ADMIN";
export const APP_DEVELOPED_BY = "Brudite Team";
export const CopyRightYear = "2023-2024";
export const BREW_USER_STORAGE_KEY = "selectedBrewUser";

export const SKILLBREW_BADGES_API_BASE_URL =
  process.env.REACT_APP_SKILLBREW_BADGES_API_BASE_URL ?? "";

/** CDN base for CMS image previews in admin (no trailing slash). */
export const CMS_CDN_BASE_URL =
  process.env.REACT_APP_CMS_CDN_BASE_URL?.replace(/\/+$/, "") ?? "";

/** Public marketing site for “View public” links (no trailing slash). */
export const MARKETING_SITE_URL =
  process.env.REACT_APP_MARKETING_SITE_URL?.replace(/\/+$/, "") ?? "";
